import React, {useEffect, useState} from 'react'
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit'
import TextInput from "app/Components/Shared/TextInput/TextInput";
import {
  setRestrictedCode, closeModal, removeOtpData, setSaleOtpStep
} from "app/Components/Block/CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice";
import {createOtpLoginStep02, setOtpError} from "app/utilities/authentication/authenticationSlice";
import {connect} from "react-redux";
import {hideAppLoader, showAppLoader} from "app/Components/Shared/Loader/LoaderSlice";
import {saleActiveStep, saleOTPSteps} from "app/Components/Block/CellcomAbroadLobbyBlock/cellcomAbroadVariables";
import Image from '../../../Shared/Image/image';
const RestrictedCodePopup = (props) => {
  const [restrictedCodeError, setRestrictedCodeError] = useState(null);

  async function submitRestrictedCode() {
    setRestrictedCodeError(null);
    if (!props.data.otpCodeForm.restrictedCode) {
      setRestrictedCodeError("אנא הכנס קוד זיהוי");
      return;
    }
    props.showAppLoader();
    const isFamilyProcess = props.data.otpData?.isFamilyProcess;
    await props.createOtpLoginStep02({
      phoneNumber: isFamilyProcess ? props.data.otpDataChildren.otpPhone : props.data.otpPhoneForm.phone,
      otpCode: isFamilyProcess ? props.data.otpCodeForm.verifyCode : props.data.otpCodeForm.verifyCode,
      guid: props.data.otpData.step1Ticket,
      restrictCode: props.data.otpCodeForm.restrictedCode
    }).then((result) => {
      if (result.payload.isSuccess) {
        if(props.data.isRestrictedCodePopUpFromTicket){
          props.submitValidateCustomerType();
        }
        props.closeModal();
      }
      else {
        switch (result.payload.codeError) {
          case '1003':
            props.removeOtpData();
            props.setOtpError("קוד שקיבלתם כבר לא בתוקף. כדי לשמור על הפרטים שלכם, נתחיל את התהליך מחדש");
            props.closeModal();
            break;
          case '1004':
            props.removeOtpData();
            props.setOtpError("משהו השתבש, אנא נסו שוב במועד מאוחר יותר");
            props.closeModal();
            break;
          case '36':
            setRestrictedCodeError("יש טעות בקוד, שננסה שוב?");
            break;
        }
      }
    props.hideAppLoader();
    })}

    return (
      <div className='restricted-code-popup'>
        <Image src={require('../../OTPLoginBlock/Assets/SVG/cellcomIcon.svg')} />
        <h4 className='title'>מה קוד הזיהוי שהגדרת?</h4>
            <TextInput
              className='input'
              name='restricted-code'
              type='text'
              id='restricted-code'
              autoComplete='off'
              placeholder={'קוד ייחודי'}
              required='required'
              value={props.data.otpCodeForm.restrictedCode}
              onChange={(e) => props.setRestrictedCode(e.target.value)}
              error={restrictedCodeError}
            />
        <BtnSubmit text={'אישור'} onclick={submitRestrictedCode} />
      </div>
  )
}

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
  };
};

const mapDispatchToProps = {
  closeModal,
  setRestrictedCode,
  createOtpLoginStep02,
  showAppLoader,
  hideAppLoader,
  setOtpError,
  removeOtpData,
  setSaleOtpStep
};

export default connect(mapStateToProps, mapDispatchToProps)(RestrictedCodePopup);
